// extracted by mini-css-extract-plugin
export var dropdownIcon = "_i2-6";
export var imgContainer = "_i2-3";
export var menuIcon = "_i2-5";
export var pillWrapper = "_i2-2";
export var pillsContainer = "_i2-1";
export var subscriptionCard = "_i2-0";
export var subscriptionLogo = "_i2-4";